import * as React from 'react';
import { IAppPropsWithRoute } from '../../../common/types';
import { withRouter } from 'react-router-dom';
import { useState } from 'react';
import ViewPCRWidget from './ViewPCRWidget';
import { useDispatch, useSelector } from 'react-redux';
import { showNavbar } from '../../../store/modules/appStateSlice';

interface ViewPCRPageProps extends IAppPropsWithRoute {

};

function ViewPCRPage(props: ViewPCRPageProps): JSX.Element {
    const dispatch = useDispatch();
    //const { authStore } = useSelector((state: RootState) => state);
    React.useEffect(() => {
        dispatch(showNavbar(false));
    }, [])
   
    return (
        <React.Fragment>
            <ViewPCRWidget page = {(props?.match?.params?.page) ?? 0}/>
        </React.Fragment>
    );
}

export default React.memo(withRouter(ViewPCRPage));